import { useCallback, useMemo, useState } from 'react'
import AccountLockedDialog from './AccountLockedDialog'
import PricingDialog from './PricingDialog'
import { useAuthState } from '../../auth/auth'

const Paywall = () => {
  const authState = useAuthState()
  const accountIsLocked = useMemo(() => authState.isLocked, [authState.isLocked])

  const [showPricingDialog, setShowPricingDialog] = useState(false)

  const handleUpgradeClick = useCallback(() => {
    setShowPricingDialog(true)
  }, [])

  const handlePricingClose = useCallback(() => {
    setShowPricingDialog(false)
  }, [])

  const accountLockedDialogOpen = useMemo(() => {
    if (showPricingDialog) {
      return false
    }
    return accountIsLocked
  }, [accountIsLocked, showPricingDialog])

  return (
    <>
      <AccountLockedDialog onUpgradeClick={handleUpgradeClick} open={accountLockedDialogOpen} />
      <PricingDialog open={showPricingDialog} onClose={handlePricingClose} />
    </>
  )
}

export default Paywall
